import { createAsyncThunk } from '@reduxjs/toolkit'
import MediaLog from './media-log-model'
import {
  delete_mediaLog,
  load_mediaLogs,
  store_mediaLog,
} from './mediaLog-service'

export const LoadMediaLogsAsync = createAsyncThunk<any, any>(
  'composer/load/mediaLog',
  async (params: { uid: string }) => {
    return await load_mediaLogs(params)
  },
)

export const CreateMediaLogAsync = createAsyncThunk<any, any>(
  'composer/create/mediaLog',
  async (params: MediaLog) => {
    return await store_mediaLog(params)
  },
)

export const DeleteMediaLogAsync = createAsyncThunk<any, any>(
  'composer/delete/mediaLog',
  async (params) => {
    return await delete_mediaLog(params)
  },
)
